import type { IconProps } from './types';
import './icons.css';

export default function ArrowDiagonal({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 14}
      height={height || 14}
      viewBox="0 0 14 14"
      className={`icon icon-arrow-diagonal ${className || ''}`}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M13 1 1 13M13 1H3.77M13 1v9.23"
      />
    </svg>
  );
}
